import { render, staticRenderFns } from "./regionalPerspective.vue?vue&type=template&id=d5b675ea&scoped=true"
import script from "./regionalPerspective.vue?vue&type=script&lang=js"
export * from "./regionalPerspective.vue?vue&type=script&lang=js"
import style0 from "./regionalPerspective.vue?vue&type=style&index=0&id=d5b675ea&prod&lang=scss&scoped=true"
import style1 from "./regionalPerspective.vue?vue&type=style&index=1&id=d5b675ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b675ea",
  null
  
)

export default component.exports